import * as types from "../actions/types";


const initialState = {
    disconnectedcount: null,
    displaygroups: null,
    secondarydisplaygroups: null,
    callcenters: null,
    secondarycallcenters: null,
    freecalllinks: null,
    recalllinks: null,
    callapps: null,
    decisiontrees: null,
    portalagents: null,
    secondaryportalagents: null,
    displays: null,
    secondarydisplays: null,
    display: null,
    log: null,
    dashboardzoneId: null,
    calllogszoneId: null
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_DISPLAYS_COMPLETED:
            return Object.assign({}, state, {
                displays: action.payload
            });
        case types.GET_PORTALAGENTS_COMPLETED:
            return Object.assign({}, state, {
                portalagents: action.payload
            });
        case types.GET_PORTALAGENTS_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondaryportalagents: action.payload
            });
        case types.GET_DISPLAYS_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondarydisplays: action.payload
            });
        case types.GET_DISPLAYGROUPS_COMPLETED:
            return Object.assign({}, state, {
                displaygroups: action.payload
            });
        case types.GET_CALLCENTERS_COMPLETED:
            return Object.assign({}, state, {
                callcenters: action.payload
            });
        case types.GET_CALLCENTERS_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondarycallcenters: action.payload
            });
        case types.GET_FREECALLLINKS_COMPLETED:
            return Object.assign({}, state, {
                freecalllinks: action.payload
            });
        case types.GET_RECALLLINKS_COMPLETED:
            return Object.assign({}, state, {
                recalllinks: action.payload
            });
        case types.GET_FREECALLAPP_COMPLETED:
            return Object.assign({}, state, {
                callapps: action.payload
            });
        case types.GET_FREECALLLINK_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondaryFreeCallLinks: action.payload
            });
        case types.GET_DECISIONTREES_COMPLETED:
            return Object.assign({}, state, {
                decisiontrees: action.payload
            });
        case types.GET_DISPLAYGROUPS_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondarydisplaygroups: action.payload
            });
        case types.GET_DISPLAYSDISCONNECTEDCOUNT_COMPLETED:
            return Object.assign({}, state, {
                disconnectedcount: action.payload
            });
        case types.GET_DISPLAY_COMPLETED:
            return Object.assign({}, state, {
                display: action.payload
            });
        case types.GET_LOG_UPDATED:
            return Object.assign({}, state, {
                log: action.payload
            });
        case types.GET_DASHBOARDZONEID_UPDATED:
            return Object.assign({}, state, {
                dashboardzoneId: action.payload
            });
        case types.GET_CALLOGZONEID_UPDATED:
            return Object.assign({}, state, {
                calllogszoneId: action.payload
            });
        default:
            return state;
    }
};
